import React, { FC, useEffect, useState } from "react";
import { CopyToClipboard } from "@UI/Components/Icons/CopyToClipBoard";
import { useClipboard } from "@UI/hooks/useClipboard";
import { Icon } from "@UI/Components/Icon/Icon";
import { Tooltip } from "@UI/Components/Tooltip/Tooltip";
import { Box } from "@UI/Components/Box/Box";
import useI18n from "@I18n/hooks/useI18n";
import messages from "./messages";
import useMediaQuery from "@UI/hooks/useMediaQuery";

interface Props {
  text: string;
  label?: string;
}

export const CopyToClipboardIcon: FC<Props> = ({ text }) => {
  const { onCopy, hasCopied } = useClipboard(text);
  const { formatMessage } = useI18n();
  const { isMobile } = useMediaQuery();

  const [copiedDone, setCopiedDone] = useState<boolean>(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  useEffect(() => {
    if (hasCopied) {
      setCopiedDone(true);
    }
  }, [hasCopied]);

  return (
    <Tooltip
      label={formatMessage(copiedDone ? messages.copied : messages.copy)}
      placement="right"
      closeOnClick={false}
      background={copiedDone ? "seaGreen" : "gray"}
      closeDelay={1000}
      isOpen={copiedDone || (isTooltipOpen && !isMobile)}
      onClose={() => {
        setCopiedDone(false);
      }}
    >
      <Box>
        <Icon
          pl="3"
          onMouseLeave={() => setIsTooltipOpen(false)}
          onMouseEnter={() => setIsTooltipOpen(true)}
          onClick={onCopy}
          as={CopyToClipboard}
          cursor="pointer"
          color="gray.500"
          _hover={{ color: "gray.700" }}
        />
      </Box>
    </Tooltip>
  );
};
